import Badge from './Badge';

export default {
  id: 'blank_1',
  title: 'Blank_1',
  premium: true,
  supportsNoSubline: true,
  colors: 1,
  BadgeComponentStateless: Badge,
  languageSpecificSettings: {
    de: {
      small: true
    },
    fr: {
      small: true
    },
    es: {
      small: true
    },
    nl: {
      small: true
    },
    fin: {
      small: true
    },
    pt: {
      small: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/badges/blank_1/index.js